module.exports = __webpack_public_path__ + "static/img/Pillow.f61758a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yiBrand/design/Pillow.png
// module id = Z+Nt
// module chunks = 0